module.exports = __webpack_public_path__ + "img/explorer.1d241c47.png";